{#if currChapterSlug}
  <div class="{currChapterSlug ? 'is-fixed-top' : ''}">
    <div class="container">
      <div class="columns">
        <div class="column is-one-fifth-tablet">
          <p class="buttons">
            <button class="button" on:click="{() => push('/platzreife')}">
              <span class="icon is-small">
                <i class="fas fa-chevron-left"></i>
              </span>
              <span>Zu den Lektionen</span>
            </button>
          </p>
        </div>
        <div class="column is-three-fifth-tablet">
          <ul class="steps is-horizontal has-content-centered">
            {#each navItems as item}
              <li
                class="steps-segment {item.isClickable && !item.isClickable() ? '' : 'is-clickable'} {up && item.isActive() ? 'is-active' : ''}"
                on:click="{() => switchNav(item)}"
              >
                <span
                  class="steps-marker {up && item.isActive() && item.slug !== 'beantwortet' ? 'is-hollow' : ''}"
                >
                  <span class="icon"> <i class="fa fa-{item.icon}"></i> </span>
                </span>
                <div class="steps-content">
                  <p class="is-size-5 is-size-6-mobile">{item.title}</p>
                </div>
              </li>
            {/each}
          </ul>
        </div>
        <div class="column is-one-fifth-tablet has-text-right">
          <LogoutBtn />
        </div>
      </div>
    </div>
  </div>
{/if}

<script>
import { onDestroy, onMount } from "svelte";
import { push } from "svelte-spa-router";
import { chapters, currentChapter, chapterNav, userProgress } from "./stores";
import LogoutBtn from "./LogoutBtn.svelte";
import { examSvc as _ } from "./services";

export let segment;
export let params = {};

let chaptersData, currChapterSlug, navItems, up;

const switchNav = (item) => {
  if (item.isClickable && !item.isClickable()) {
    return;
  }
  push("/platzreife/" + currChapterSlug + "/" + item.slug);
};

onMount(() => {
  chapters.subscribe((value) => {
    chaptersData = value;
    if (chaptersData && params.lektion && params.lektion !== currChapterSlug) {
      let foundChapter = chaptersData.find((c) => c.slug === params.lektion);
      if (foundChapter) {
        currentChapter.set(foundChapter);
      } else {
        console.error("Unbekannter Chapter.", params.lektion);
        push("/platzreife");
      }
    }
  });

  currentChapter.subscribe((ch) => {
    if (ch == undefined) {
      return;
    }
    currChapterSlug = ch.slug;
  });

  chapterNav.subscribe((value) => {
    navItems = value;
  });

  userProgress.subscribe((data) => (up = data));

  document.body.classList.add("has-chapter-nav");
});
onDestroy(() => {
  document.body.classList.remove("has-chapter-nav");
});
</script>

<style type="text/scss">
@import "./scss/colors";
@import "./scss/shared";

@media only screen and (max-width: 576px) {
  :global(body.has-chapter-nav) {
    padding-top: 90px;
  }
}
.nav-chapters {
  .column {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    transition: background-color 0.3s ease;
    border-bottom: 10px solid transparent;
  }
  .active {
    border-bottom: 10px solid #555555;
  }
  .is-clickable:hover {
    background-color: #ebebeb;
  }
  img {
    max-width: 100%;
    border-radius: 2px;
    border: 2px solid transparent;
  }
}
// .active {
//   text-decoration: underline;
// }
.chapter-started img {
  border-color: $color-warning;
}
.chapter-success img {
  border-color: $color-success;
}
.chapter-failed img {
  border-color: $color-danger;
}
.is-clickable {
  cursor: pointer;
}
</style>
